import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'none',
  color: 'white',
  fontSize: 'xs',
  fontWeight: 'medium',
};
